module.exports = __webpack_public_path__ + "img/mw.5951996.svg";